module.exports = __webpack_public_path__ + "static/media/profile_sample_excel.cd056520.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/sample/profile_sample_excel.JPG
// module id = 1365
// module chunks = 1